import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import Carousel, { consts } from "react-elastic-carousel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons"

import Intro from "../../components/common/intro"
import Container from "../../components/common/container"
import RecipeBox from "../../components/recipes/recipe-box"

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 0 !important;
`

const CarouselContainer = styled.div`
  position: relative;

  ${props =>
    props.hasBottomMargin &&
    `
    margin-bottom: 6rem;
  `}

  > div {
    position: relative;
  }

  .rec-item-wrapper {
    > div {
      margin-bottom: 0;
    }

    li {
      > div {
        max-width: 52rem;
        margin: 0 auto;
      }
    }
  }

  .gatsby-image-wrapper {
    width: 100%;
  }
`

const StyledArrowButton = styled.button`
  color: #959595;
  background: transparent;
  font-size: 2.5rem;
  cursor: pointer;
  border: 0;
  transition: 200ms linear;

  @media (min-width: 1025px) {
    position: absolute;
    font-size: 4rem;
    top: 50%;
    margin-top: -3rem;

    &.next {
      font-family: swiper-icons;
      right: -3rem;
    }

    &.prev {
      font-family: swiper-icons;
      left: -3rem;
    }

    &:hover {
      color: ${props => props.theme.crockpot.main};
    }
  }

  &:disabled {
    cursor: default;
    color: #959595 !important;
    opacity: 0;
  }
`

const breakpoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2 },
]

const ItemsCarousel = ({ items = [], title = "", hasBottomMargin = true }) => {
  return (
    <Container>
      <Wrapper>
        {title && <Intro title={title} />}
        <CarouselContainer hasBottomMargin={hasBottomMargin}>
          <Carousel
            breakPoints={breakpoints}
            renderPagination={({ pages, activePage, onClick }) => <div></div>}
            renderArrow={({ type, onClick, isEdge }) => {
              const pointer =
                type === consts.PREV ? (
                  <FontAwesomeIcon icon={faChevronLeft} />
                ) : (
                  <FontAwesomeIcon icon={faChevronRight} />
                )

              const buttonDirection = type === consts.PREV ? "prev" : "next"

              return (
                <StyledArrowButton
                  className={buttonDirection}
                  onClick={onClick}
                  disabled={isEdge}
                  aria-label={buttonDirection}
                >
                  {pointer}
                </StyledArrowButton>
              )
            }}
          >
            {items.map((item, index) => (
              <RecipeBox
                recipe={item}
                key={item.contentful_id + index}
                isProductPage={true}
              />
            ))}
          </Carousel>
        </CarouselContainer>
      </Wrapper>
    </Container>
  )
}

ItemsCarousel.propTypes = {
  items: PropTypes.array,
  hasBottomMargin: PropTypes.bool,
  title: PropTypes.string,
}

export default ItemsCarousel
